<template>
  <div class="all">
    <div class="title">Your Personal</div>
    <page-editer
      ref="editer-library"
      :modelData.sync="data"
      :render="renderData"
      :hideDeleteBtn="true"
      :handleLoad="Loaded"
      :handlerSave="Save"
    ></page-editer>
    <!-- <el-pagination
            :hide-on-single-page="true"
            background
            layout="total,sizes,prev, pager, next,jumper"
            :total="total"
            :pager-count="5"
            :page-size.sync="pageSize"
            :current-page.sync="nowPage"
            :page-sizes="[40, 50, 60, 100]"
    ></el-pagination>-->
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      pageSize: 40,
      total: 0,
      nowPage: 1,
      tableLoad: false,
      tableSelect: [],
      renderData: [
        {
          key: "Workout list Select",
          type: "transfer2",
          modelName: "workoutList",
          transferBase: [],
          repeat: false,
          must: true,
          BasekeyID: "id",
          DatakeyID:'workoutId',
          TreeTableState: true,
          noPagin:true,
          showRender: [
            {
              name: "Name",
              modelName: "title"
            }
          ],
          searchRander:[
            {
              placeholder: "Name",
              modelName: "title",
              type:'input'
            }
          ],
          dataRander: [
            {
              name: "Name",
              modelName: "title"
            }
          ],
          TreeTableRander: [
            {
              name: "Name",
              modelName: "title"
            },
            {
              type:'imageUpload',
              modelName:'tabletCoverImageUrl',
              name:'Tablet Cover Image',
              width:140,
              editor:true
            },
            {
              type:'imageUpload',
              modelName:'phoneCoverImageUrl',
              name:'Phone Cover Image',
              width:140,
              editor:true
            },
            {
              type:'imageUpload',
              modelName:'tabletDetailImageUrl',
              name:'Tablet Detail Image',
              width:140,
              editor:true
            },
            {
              type:'imageUpload',
              modelName:'phoneDetailImageUrl',
              name:'Phone Detail Image',
              width:140,
              editor:true
            },
            {
              modelName:'shortLink',
              name:'Short Link',
              width:140,
            },
          ],
          BaseLocalSearch:true,
          getBase: config => {
            config = config || {};
            return new Promise(resolve => {
              config = {
                pageSize: 100,
                pageNum: 1,
                ...config
              };
              this.$request("/manage/workout/list", config, res => {
                if (res.data.code === 200) {
                  res.data.list = res.data.data
                  resolve(res.data);
                }
              },'post',true,true);
            });
          }
        }
      ],
      data: {
        name: "",
        description: ""
      }
    };
  },
  methods: {
    handleSelectionChange(val) {
      this.tableSelect = val;
    },
    deleteData() {
      this.$confirm("Confirm delete？", "", { type: "warning" }).then(() => {
        1;
      });
    },
    Save() {
      let uploadData = this.$deepCopy(this.data);
      // uploadData.workoutList = uploadData.workoutList.map(item => item.id)
      this.renderData.some(item => {
        // 多选数组转字符串数组
        if (item.type === "selects" && this.data[item.modelName]) {
          uploadData[item.modelName] = this.data[item.modelName].toString();
        }
      });
      this.$request("/manage/personal/save", uploadData, res => {
        if (res.data.code === 200) {
          this.$message({
            message: "save success",
            type: "success"
          });
          this.Loaded()
        }
      });
    },
    Loaded() {
      console.log("load");
      this.show = true;
      this.$request(
        `/manage/personal/detail`,
        {},
        res => {
          let data = res.data.data;
          this.renderData.some(item => {
            if (item.type === "selects" && data[item.modelName]) {
              data[item.modelName] = data[item.modelName].split(",");
            }
          });
          this.data = data;
        },
        "get",
        true
      );
      // 获取exercise的列表 导入进 transfer
      // this.$request("/manage/workout/list", {}, res => {
      //   if (res.data.code === 200) {
      //     this.renderData.some(item => {
      //       if (item.modelName === "workoutList") {
      //         item.transferBase = res.data.data;
      //       }
      //     });
      //   }
      // });
    }
  },
  created() {
    // this.nowPage = 1;
  }
};
</script>

<style scoped>
.all {
  box-sizing: border-box;
  padding: 0 20px;
  text-align: left;
  margin-top: 30px;
}
.title {
  font-size: 20px;
  margin: 40px 0 0;
}
.btns {
  margin: 0 0 0 2px;
  text-align: right;
}
.el-table {
  box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.05);
}
.all >>> .tableHeadr th {
  background-color: rgb(121, 174, 200) !important;
  color: white;
}
.all >>> .table-name i:hover {
  color: #447e9b !important;
  cursor: pointer;
}
.all >>> .tableCell {
  color: #447e9b;
  overflow: hidden;
  height: 23px;
  text-overflow: ellipsis;
  white-space: pre;
}
.all >>> .tableCell:hover {
  cursor: pointer;
}
.el-pagination {
  text-align: right;
  margin: 20px 0;
}
</style>